/**
 * Link content policy configuration.
 *
 * Centralized toggle to control whether URLs are allowed in free-text inputs
 * across booking, rescheduling, and cancellation flows. Forms should call
 * isLinkAllowed() to decide whether to enforce URL-blocking validation.
 *
 * Typical usage:
 *   import {isLinkAllowed, setLinkAllowed} from 'Config/linkPolicy';
 *   if (!isLinkAllowed()) { /* apply URL validation */ /* }
 *   // Optionally toggle via feature flag or API response:
 *   setLinkAllowed(true);
 */
// Centralized link content policy for forms
// Default: links are not allowed in free-text fields
let linkAllowed = false;

/**
 * Basic URL detector for free-text fields.
 * Matches common URL patterns like http(s)://, www., or bare domains with TLDs.
 * @param {?string} value input text
 * @return {boolean} true if input appears to contain a URL; false otherwise
 */
export function containsUrl(value) {
  if (!value) return false;
  const urlRegex = /(https?:\/\/|www\.)/i;
  const domainRegex = /\b[a-z0-9-]+(\.[a-z0-9-]+)+\b\/?/i;
  return urlRegex.test(value) || domainRegex.test(value);
}

/**
 * Sets whether links are allowed in free-text fields.
 * @param {boolean} value true to allow links, false to block links
 * @return {void}
 */
export function setLinkAllowed(value) {
  linkAllowed = !!value;
}

/**
 * Returns whether links are allowed in free-text fields.
 * @return {boolean} true if links are allowed; false otherwise
 */
export function isLinkAllowed() {
  return linkAllowed;
}


